// Restful react only automatically parses JSON responses if they have the content type application/json but symfony
// returns 'application/problem+json' for its errors so we need to parse it manually.
export default function fixErrorData(headers: Headers, error: {data: unknown}) {
    if (!headers) {
        // Headers can be null on a network error, just ignore the error in this case
        return;
    }

    const contentType = headers.get('content-type');
    if (typeof error.data === 'string' && contentType && contentType.startsWith('application/problem+json')) {
        error.data = JSON.parse(error.data);
    }
}
